import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

export type FooterType = {
  className?: string;
};

const Footer: FunctionComponent<FooterType> = ({ className = "" }) => {
  const { t } = useTranslation();

  return (
    <section
      className={`
        self-stretch overflow-hidden flex flex-col lg:flex-row
        items-center lg:items-end justify-center lg:justify-between
        py-7 px-5 lg:px-[100px] xl:px-[200px] 2xl:px-[360px] box-border
        max-w-full gap-5 text-left text-xl text-black font-inter
        mq450:flex-col mq450:justify-start
        ${className}
      `}
    >
      <div
        className={`
          w-full lg:w-auto flex flex-col items-start lg:items-left
          justify-end gap-2.5 lg:gap-4
        `}
      >
        <div className="relative text-base lg:text-xl">
          Copyright © {new Date().getFullYear()} YouWo.AI
        </div>
        <div className="relative text-base lg:text-xl">
          {t("footer.poweredBy")}
        </div>
      </div>

      <div className="flex flex-col items-end justify-start h-full pt-2 lg:pt-0">
        <a
          href="https://discord.gg/wetdx6DG4S"
          className="flex items-center gap-2 text-base lg:text-lg font-bold text-black no-underline transition-colors hover:text-gray-600"
        >
          <img src="/icons/discord.svg" width={40} height={40} />
          <span>Discord</span>
        </a>
      </div>
    </section>
  );
};

export default Footer;
